import store from "@/store";
import Vue from "vue";

function errorHandler(error) {
  return new Promise((resolve, reject) => {
    reject(error);
  });
}

function successHandler(resp) {
  if (resp) {
    return resp;
  } else {
    throw {
      name: "APIRequestError",
      message: "API request was not successful"
    };
  }
}

export default {
  territoryFeedbackLogin(crmUserId) {
    const alignDomain = this.convertToFeedbackURL(
      store.getters.territoryServerURL
    );
    const sfSession = Vue.$cookies.get("sfSession");
    const sfEndpoint = Vue.$cookies.get("sfEndpoint");

    return fetch(
      `https://${alignDomain}/align/feedback/login?crmUserId=${crmUserId}`,
      {
        headers: {
          "SF-Session": sfSession,
          "SF-Endpoint": sfEndpoint
        }
      }
    )
      .then(res => res.json())
      .then(successHandler, errorHandler);
  },
  convertToFeedbackURL(alignServer) {
    return alignServer.replace("-app.", "-feedback.");
  },
  getModelNameFromId(resp, id) {
    let searchResults = [];
    this.territoriesResultList(resp, searchResults);
    const ID_CONST = "Id";
    return searchResults.filter(searchResult => searchResult[ID_CONST] === id);
  },
  formatFeedbackLoginResults(resp) {
    let searchResult = [];
    this.territoriesResultList(resp, searchResult);
    return searchResult;
  },
  territoriesResultList(resp, searchResult) {
    if (resp.data) {
      searchResult.push({
        Id: resp.data.id,
        Name: resp.data.name,
        Formatted_Name_vod__c: resp.data.name
      });
    }
    if (resp.children) {
      resp.children.forEach(terr =>
        this.territoriesResultList(terr, searchResult)
      );
    }
  }
};
